"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weekdays = exports.months = exports.defaultStartYear = exports.defaultStartDate = void 0;
const months = exports.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const weekdays = exports.weekdays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
const defaultStartDate = exports.defaultStartDate = new Date('01-01-1900');
const defaultStartYear = exports.defaultStartYear = 1900;